import * as React from "react";
import { TextField } from "@origin-digital/ods-core";
import { Field, useFormikContext } from "formik";
import { IGeneralTextField } from "../FormComponents/GeneralTextField";
import { apiClient } from "src/api/apiService";
import { PremiseDetails } from "src/components/Changes/types";
import { ChangeRequestFormValues } from "./formValue";
import { NmiStatusEnum } from "./StatusAlert";

const Nmi: React.FC<{ requestType: string }> = ({ requestType }) => {
  return (
    <Field
      component={NmiField}
      name="nmi"
      label="NMI"
      requestType={requestType}
    />
  );
};

const NmiField = (props: IGeneralTextField & { requestType: string }) => {
  const {
    field,
    label,
    id,
    type,
    startIcon,
    helperText,
    maxLength,
    disabled,
    requestType,
  } = props;

  const { errors } = useFormikContext<ChangeRequestFormValues>();
  const formikError = errors.nmi;
  const { value, onChange } = field;
  const [error, setError] = React.useState<string>();
  const {
    setFieldValue,
    values: { nmiStatus },
  } = useFormikContext<ChangeRequestFormValues>();
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    const validateNmi = async () => {
      if (value && (value.length === 10 || value.length === 11)) {
        setIsLoading(true);
        try {
          const response = await apiClient.get<{
            nmi_status: string;
            premise: PremiseDetails;
          }>(`/nmi/validate`, {
            params: {
              nmi: value,
              requestType,
            },
          });
          const { nmi_status, premise } = response.data;
          setFieldValue("nmiStatus", nmi_status);
          setFieldValue("premise", premise);
          if (nmi_status === NmiStatusEnum.NOT_FOUND) {
            setError("NMI not found");
          } else {
            setError(undefined);
          }
        } catch (err) {
          setError("Error validating NMI");
        } finally {
          setIsLoading(false);
        }
      }
    };

    validateNmi();
  }, [value]);

  const getEndIcon = () => {
    if (isLoading) {
      return "validating";
    }
    if (nmiStatus === null) {
      return undefined;
    }
    if (error || nmiStatus === NmiStatusEnum.NOT_FOUND) {
      return "error";
    }
    if (nmiStatus === NmiStatusEnum.ELIGIBLE) {
      return "success";
    }
    return undefined;
  };

  return (
    <TextField
      {...field}
      onChange={(e) => {
        const numericValue = e.target.value.replace(/[^0-9a-zA-Z]/g, "");
        if (numericValue.length <= 10) {
          e.target.value = numericValue;
          onChange(e);
        }
      }}
      id={id}
      variant="outlined"
      label={label}
      error={!!formikError || !!error}
      helperText={formikError || error || helperText}
      hideHelperTextSpace
      type={type}
      startIcon={startIcon}
      maxLength={maxLength}
      endIcon={getEndIcon()}
      disabled={disabled}
    />
  );
};

export default Nmi;
